module.exports = __webpack_public_path__ + "static/img/menage3.9c01ff3b.png";